// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"db1f5b79","453":"e1972beb"}[chunkId] + ".chunk.js";
};